import React, { useState, useEffect, useRef } from "react";
import DoneToggle from "globalComponents/DoneToggle";
import BreakStroke from "../itemLists/BreakStroke";
import ChecklistItemInput from "./ChecklistItemInput";
import store from "glassRedux/store";

import {
  createChecklistItem,
  addChecklistItem,
  updateChecklistItemName,
  toggleChecklistItem,
  mergeChecklistItemWithAbove,
  isPending,
} from "shared/checklists/redux/checklistSlice";

export default function ChecklistItem(props) {
  const {
    hasBreak,
    name,
    ciIndex,
    id,
    setCursorPosition,
    inputRefs,
    itemId,
    isUnsaved,
    isNew,
  } = props;

  const [currentName, setCurrentName] = useState(name);
  const [itemDone, setItemDone] = useState(props.done);
  const [isNewAndNeedsFocus, setIsNewAndNeedsFocus] = useState(isNew);
  const itemRef = useRef(null);
  const nameRef = useRef(name);

  useEffect(() => {
    if (name !== currentName) {
      setCurrentName(name);
      nameRef.current = name;
    }
  }, [name]);

  useEffect(() => {
    if (isNewAndNeedsFocus) {
      itemRef.current && itemRef.current.focus();
    }
  }, [isNewAndNeedsFocus]);

  function handleChecklistItemKeyPress(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      splitIntoNewItem();
    }
  }

  function handleChecklistItemKeyDown(event) {
    console.log("inputRefs: ", inputRefs);
    if (event.key === "Backspace") {
      if (ciIndex !== 0) {
        if (window.getSelection().anchorOffset === 0) {
          const nameLength = currentName.length;
          store.dispatch(
            mergeChecklistItemWithAbove({
              index: ciIndex,
              name: currentName,
              ...{ id, isUnsaved },
            })
          );
          inputRefs.splice(ciIndex, 1);

          if (ciIndex > 0) {
            setTimeout(() => {
              setCursorPosition({
                element: inputRefs[ciIndex - 1].current,
                rightOffset: nameLength,
              });
            }, 100);
          }
        }
      }
    }
  }

  function splitIntoNewItem() {
    const trimmedName = currentName.replace(/[&]?nbsp;/gi, " ").trim();
    const selectionEnd = window.getSelection().anchorOffset;
    const name1 = trimmedName.slice(0, selectionEnd);
    const name2 = trimmedName.slice(selectionEnd, currentName.length);
    if (name1 && name2) {
      setCurrentName(name1);
      nameRef.current = name1;
    }
    store.dispatch(addChecklistItem({ index: ciIndex, ...{ name1, name2 } }));
  }

  function saveName(newName) {
    if (isUnsaved && !isPending(id, store.getState())) {
      const action = createChecklistItem({
        name: newName,
        itemId: itemId,
        index: ciIndex,
        localId: id,
      });
      store.dispatch(action);
    } else {
      if (name !== newName) {
        console.log("name: ", name);
        console.log("newName: ", newName);
        store.dispatch(updateChecklistItemName({ id: id, name: newName }));
      }
    }
  }

  function itemName() {
    if (!itemDone) {
      return (
        <ChecklistItemInput
          {...{
            name,
            saveName,
            isUnsaved,
            itemRef,
            nameRef,
            currentName,
            setCurrentName,
            inputRefs,
            ciIndex,
          }}
        />
      );
    } else {
      return <div className="checklist-item-name">{currentName}</div>;
    }
  }

  function handleDoneChange(newDone) {
    store.dispatch(
      toggleChecklistItem({
        id: id,
        done: newDone,
        name: currentName,
        index: ciIndex,
      })
    );
  }

  return (
    <div>
      {hasBreak && <BreakStroke />}
      <div
        onKeyPress={handleChecklistItemKeyPress}
        onKeyDown={handleChecklistItemKeyDown}
        className={"checklist-item" + (itemDone ? " done" : "")}
        data-index={ciIndex}
      >
        <DoneToggle
          isChecklist={true}
          {...{ setItemDone, itemDone, handleDoneChange }}
        />
        {itemName()}
      </div>
    </div>
  );
}
